export const StyleUtil = {
  buttonAction:
    'mentem-button bg-white text-black border border-black rounded-full px-4 py-2 hover:text-white hover:bg-primary hover:border-primary shadow-lg normal-case font-bold',
}
